"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import corporateIllustration from "../assets/images/settings/corporate.svg";
import { SecuredFooter } from "./ui/secured-footer";

const BusinessAccountPreApplication = () => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 21L10.5 14L15.167 18.667L24.5 7"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 7H24.5V14"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      text: "Access to enhanced business financial visibility.",
    },
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.167 3.5L5.833 16.333H14L12.833 24.5L22.167 11.667H14L15.167 3.5Z"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      text: "Access to enhanced business financial visibility.",
    },
    {
      icon: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 14H7V24.5H3.5V14Z"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 7H14V24.5H10.5V7Z"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 10.5H21V24.5H17.5V10.5Z"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.5 3.5V24.5"
            stroke="#423e51"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      text: "Access to enhanced business financial visibility.",
    },
  ];

  return (
    <div className="w-full bg-white rounded-3xl border border-[#ebe9ef] flex flex-col items-center relative min-h-[780px]">
      {/* Center Content */}
      <div className="flex flex-col items-center justify-center flex-grow w-full max-w-[384px] px-4 py-12 gap-[45px]">
        {/* Briefcase Illustration */}
        <div className="w-[194px] h-[136px] flex items-center justify-center">
          <img
            src={corporateIllustration}
            alt="Business Account"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Title & Benefits */}
        <div className="flex flex-col items-center gap-6 w-full">
          <h1 className="text-[32px] font-semibold leading-[40px] text-[#33125f] text-center">
            Apply for a business account
          </h1>

          {/* Benefits List */}
          <div className="flex flex-col gap-6 w-full">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-[18px] w-full">
                <div className="shrink-0 w-7 h-7 flex items-center justify-center">
                  {benefit.icon}
                </div>
                <p className="text-[20px] font-normal leading-[32px] text-[#423e51]">
                  {benefit.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Apply Button */}
        <button
          onClick={() => {
            navigate("/kyb");
          }}
          className="w-full h-12 rounded-full text-white text-sm font-semibold leading-5 cursor-pointer hover:opacity-90 transition-opacity"
          style={{
            backgroundImage:
              "linear-gradient(65deg, #57249C 10.66%, #EB3366 113.47%)",
          }}
        >
          Apply
        </button>
      </div>

      {/* Secured Footer */}
      <SecuredFooter className="w-full p-6 justify-center border-t border-[#ebe9ef] mt-auto" />
    </div>
  );
};

export default BusinessAccountPreApplication;
